import { CatalogDelayCode } from "../models/CatalogDelayCode";
import { TreeParameters } from "../models/TreeParameter";
export const TransformDelayModelData = (
	node: CatalogDelayCode,
): TreeParameters => {
	const model: TreeParameters = {
		id: node.DelayCodeId!,
		parent: node.ParentDelayCodeId ? node.ParentDelayCodeId : 0,
		text: node.DelayCodeName,
		isAtTop: node.IsAtTop,
		isAtBottom: node.IsAtBottom,
		isEditable: node.IsEditable,
		isActive: node.IsActive,
		quickButtonEnabled: node.QuickButtonEnabled,
		sortOrder: node.SortOrder,
		data: {
			fileType: "csv",
			fileSize: "",
		},
		droppable: node.IsBranch,
	};
	return model;
};
